import { Component, forwardRef, Input, OnChanges, OnInit, ChangeDetectorRef, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';
import { DataModel } from 'app/shared/models/DataModel';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-input-listbox-react',
    templateUrl: './input-listbox-react.component.html',
    styleUrls: ['./input-listbox-react.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputListboxReactComponent),
            multi: true
        }
    ]
})

export class InputListboxReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges, AfterViewInit {

    // atributo utilizado para efetuar preenchimento de itens

    @Input() items: Array<DataModel> = [];
    @Input() dadosSubordinacao = false;
    @Input() isNumber = false;
    @Input() itemsIsValue = false;
    @Input() selectedIndex = -1;
    @Output() indiceSelecionado: EventEmitter<number> = new EventEmitter<number>();

    constructor(
    ) {
        super();
    }
    ngAfterViewInit(): void {
        if (this.itemsIsValue) {
            this.value = this.items;
        }
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.value) {
            const val = (this.isNumber ? parseInt(this.value.toString(), 0) : this.value.toString());
            if (this.control) {
                this.control.setValue(val);
                this.valorChange.emit(val);
            }
        }
        this.setAndUpdateValidators();
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.setAndUpdateValidators();
    }

    atualizarIndice(index: number): void {
        this.selectedIndex = index;
        this.indiceSelecionado.emit(index);
    }
}
